<section>
    <div class="table-container">
        <mat-tab-group (selectedIndexChange)="onTabChange($event)" [selectedIndex]="selectedTabIndex">
            <mat-tab label="Group CRM">
                <div *ngIf="customersData && selectedTabIndex === 0">
                    <app-customers-grid (editCustomerClicked)="editCustomerClicked($event)"
                                        [customerGridState]="customerGridState"
                                        [customersData]="customersData"
                                        [fuelVendors]="fuelVendors"
                                        [tags]="tags"
                                        (onCompanyFilterApplied)="onCompanyFilterApplied($event)"></app-customers-grid>
                </div>
            </mat-tab>
            <mat-tab label="Customer Pricing">
                <div *ngIf="customersPricingData && selectedTabIndex === 1">
                    <app-group-customers-pricing-grid [customersData]="customersPricingData"></app-group-customers-pricing-grid>
                </div>
            </mat-tab>
        </mat-tab-group>
        <ngx-ui-loader [loaderId]="chartName"
                       bgsColor="rgb(100, 181, 246)"
                       bgsPosition="center-center"
                       bgsType="ball-spin"
                       overlayColor="rgba(0, 0, 0, 0.1)"></ngx-ui-loader>
    </div>
</section>
